import * as yup from 'yup';

export const schema = yup.object().shape({
  is_open: yup.boolean().optional(),
  from: yup
    .string()
    .nullable()
    .when('is_open', {
      is: false,
      then: schema => schema.required('From is required'),
    }),
  to: yup
    .string()
    .nullable()
    .when('is_open', {
      is: false,
      then: schema => schema.required('To is required'),
    }),
});
